import { Dispatch } from '@reduxjs/toolkit'
import { NPaymentsApi } from 'utils/api/nPaymentsApi'

import { nPaymentsSlice } from './nPayments.slice'

export const fetchDeviceTypesAction = (nPaymentsApi: NPaymentsApi) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const deviceTypes = await nPaymentsApi.getDeviceTypes()
      dispatch(nPaymentsSlice.actions.fetchDeviceTypes(deviceTypes))
    } catch (error) {
      console.error('Cannot get device types', error)
    }
  }
}
